enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  READY = 'READY',
  STOPPED = 'STOPPED',
}

export default SubscriptionStatus;
